import {Typography, useTheme, Link,} from "@mui/material";
import {useTranslation} from "next-i18next";
import React from "react";
import {useDispatch, useSelector} from "../store";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import availCurrencies from "../generated/avail-currencies.json";
import useMediaQuery from "@mui/material/useMediaQuery";
import {fromUnixTime} from "date-fns";
import {useForex} from "../hooks/use-forex";
import {setSelectedCurrency} from "../slices/persisted-slice";


export const CurrencyChooser = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);


    const {t} = useTranslation();

    const {selectedCurrency} = useSelector((state) => state.persisted);


    const {apiTimestamp} = useForex()

    const navLanguage = (typeof navigator === "undefined") ? "en" : navigator.language.split("-")[0].toLowerCase()

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const topCurrencies = (navLanguage === "fr" || navLanguage === "es") ? ["EUR"] : ["USD"];

    if (!isMobile)
        topCurrencies.push(navLanguage === "fr" ? "USD" : "EUR", "GBP", "AUD");

    if (!topCurrencies.includes(selectedCurrency))
        topCurrencies.push(selectedCurrency);

    const dispatch = useDispatch();

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{mt: 1, textAlign: "right", whiteSpace: "nowrap"}}>
            {t("show-prices-in")}&nbsp;
            {topCurrencies.map((currentTopCurrency) => {
                return (
                    <React.Fragment key={currentTopCurrency}>
                        <Link
                            href='src/components/currency-chooser#'
                            sx={{
                                fontFamily: "monospace",
                                fontWeight: currentTopCurrency === selectedCurrency ? "bold" : "normal"
                            }}
                            onClick={(e) => {
                                e.preventDefault()
                                dispatch(setSelectedCurrency(currentTopCurrency))
                            }}
                        >
                            {currentTopCurrency}
                        </Link>
                        &nbsp;|&nbsp;
                    </React.Fragment>
                );
            })}
            <React.Fragment>
                <Link href='src/components/currency-chooser#' onClick={(e) => {
                    e.preventDefault();
                    setAnchorEl(e.currentTarget);
                }}
                      sx={{
                          fontFamily: "monospace",
                          textTransform: "lowercase"
                      }}
                >
                    {t("other")}
                </Link>
            </React.Fragment>
            <Menu
                id='lock-menu'
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {Object.keys(availCurrencies)
                    .sort()
                    .map((currencyKey, index) => (
                        <MenuItem
                            key={currencyKey}
                            selected={currencyKey === selectedCurrency}
                            onClick={(event) => {
                                dispatch(setSelectedCurrency(currencyKey));
                                setAnchorEl(null);
                            }}
                        >
                            <Typography sx={{fontFamily: "monospace", fontWeight: "bold"}}>{currencyKey}</Typography>
                            &nbsp;-&nbsp;{(availCurrencies as any)[currencyKey]}
                        </MenuItem>
                    ))}
            </Menu>
            <Box mb={1}>
                <Typography variant={"subtitle2"} sx={{color: "text.secondary", fontStyle: "oblique"}}>
                    {t("exchange-rates-updated")}{" "}
                    {apiTimestamp ?
                        new Intl.DateTimeFormat(navLanguage).format(
                            fromUnixTime(apiTimestamp))
                        :
                        "..."}
                </Typography>
            </Box>
        </Box>
    );
}
